import moment from 'moment';

class DateFormatterService {
	static humanizeDuration(duration, durationType) {
		const momentDuration = moment.duration(duration, durationType);
		const years = momentDuration.years();
		const months = momentDuration.months();
		const days = momentDuration.days();

		return `${years > 0 ? `${years}yr` : ''}${months > 0 ? `${months}mo` : ''}${days > 0 ? `${days}d` : ''}`;
	}

	static humanizeMonths(noOfMonths) {
		const momentMonth = moment.duration(noOfMonths, 'months');
		const years = momentMonth.years();
		const months = momentMonth.months();

		return `${years > 0 ? `${years}yr` : ''}${months > 0 ? `${months}mo` : ''}`;
	}

	static formatDateToSpecificFormat(objectWithDateProp, dateProperty, dateFormat) {
		return objectWithDateProp[dateProperty] && dateFormat  
			? moment(objectWithDateProp[ dateProperty ]).format(dateFormat)
			: null;
	}

	/**
	 * Same as formatDateToSpecificFormat, but for calendar dates stored at UTC midnight (license
	 * end dates, maintenance expiresOn - see client/helpers/addonPeriod.js). Formatting them in the
	 * browser's time zone shows the day before for a browser behind UTC, so they are read in UTC.
	 */
	static formatUtcDateToSpecificFormat(objectWithDateProp, dateProperty, dateFormat) {
		return objectWithDateProp[dateProperty] && dateFormat
			? moment.utc(objectWithDateProp[ dateProperty ]).format(dateFormat)
			: null;
	}
}

export default DateFormatterService;
